"use client";

import React from "react";
import { Wrench, Gauge, Settings, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  title: "Věkové Omezení",
  description: "Vstup do našeho salonu je povolen pouze osobám starším 18 let. Při pochybnostech můžeme vyžadovat průkaz totožnosti.",
  icon: "Wrench"
}, {
  id: 2,
  title: "Storno Podmínky",
  description: "Zrušení rezervace méně než 24 hodin před termínem podléhá storno poplatku ve výši 50 % z ceny vybrané služby.",
  icon: "Gauge"
}, {
  id: 3,
  title: "Platební Podmínky",
  description: "Přijímáme pouze hotovost. Platba probíhá vždy před zahájením procedury na recepci salonu.",
  icon: "Settings"
}, {
  id: 4,
  title: "Včasná Rezervace",
  description: "Doporučujeme rezervaci alespoň 48 hodin předem, abychom vám mohli zaručit dostupnost vaší oblíbené masérky.",
  icon: "Zap"
}];
const iconMap: Record<string, React.ElementType> = {
  Wrench,
  Gauge,
  Settings,
  Zap
};
export default function ServicesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242999" id="booking-policies" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <div className="w-12 h-0.5 bg-primary/40 mb-6" aria-hidden="true" />
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground uppercase tracking-widest mb-4">
            Pravidla <span className="text-primary">Salonu</span>
          </h2>
          <p className="text-muted-foreground font-default max-w-2xl text-sm md:text-base">
            Pro zajištění maximálního komfortu a diskrétnosti vás prosíme o dodržování následujících rezervačních pravidel.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => {
          const IconComponent = iconMap[service.icon];
          return <Card key={service.id} data-index={i} className="bg-card/40 backdrop-blur-[12px] border-primary/20 rounded-none transition-all duration-500 hover:scale-[1.02] hover:shadow-xl hover:border-primary/40 group">
                <CardHeader className="pb-4 pt-8 px-8">
                  <div className="mb-6">
                    <IconComponent className="w-8 h-8 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1} />
                  </div>
                  <CardTitle className="font-default text-lg uppercase tracking-widest text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8">
                  <p className="text-lg text-muted-foreground font-sans leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}